import * as en from "./en.json";
import * as fa from "./fa.json";

const messages = {
  fa,
  en,
};

export default messages;
